import agent from "../agent";

export const uploadPendingFiles = async (filesToUpload: File[]): Promise<string[]> => {
    const newFileIds: string[] = [];
    for (let f of filesToUpload) {
        const res: any = await agent.FileProvider.uploadEventFile(f);
        
        let id = res && (res._id || res.id);
        if (!id && typeof res === 'string') {
            try {
                const parsed = JSON.parse(res);
                id = parsed._id || parsed.id;
            } catch (e) {}
        }
        if (!id && res instanceof ArrayBuffer) {
            try {
                const text = new TextDecoder().decode(res);
                const parsed = JSON.parse(text);
                id = parsed._id || parsed.id;
            } catch (e) {}
        }
        if (!id && res && res.body) {
            id = res.body._id || res.body.id;
        }

        if (id) {
            newFileIds.push(id);
        } else {
            throw new Error(`Не удалось загрузить файл ${f.name}`);
        }
    }
    return newFileIds;
};
